module.exports = __webpack_public_path__ + "static/media/ic-apple.302b3552.svg";